export const LAYER_LABEL_COLOR_ATTR = 'layerLabelColor';

export const ATTACH_LINK_ICON_COLOR_ATTR = 'attachLinkIconColor';

export function isAttachLinkedElement(group) {
  if (!group?.hasName) return false;
  if (group.hasName('source')) {
    const attachId = group.getAttr('attachId');
    if (attachId !== undefined && attachId !== null) return true;
  }
  if (group.hasName('target')) {
    const attachIds = group.getAttr('attachIds');
    if (attachIds?.length) return true;
  }
  return false;
}

export function randomAttachLinkColor() {
  const h = Math.floor(Math.random() * 360);
  const s = 55 + Math.floor(Math.random() * 35);
  const l = 38 + Math.floor(Math.random() * 18);
  return `hsl(${h}, ${s}%, ${l}%)`;
}


export function paintAttachClusterLinkIconColor(stage, target) {
  if (!stage?.find || !target?.hasName?.('target')) return;
  const attachIds = target.getAttr('attachIds');
  if (!attachIds?.length) return;

  const color = randomAttachLinkColor();
  setAttachLinkIconColorAttr(target, color);

  const sources = stage.find('.source');
  if (!sources?.length) return;
  Array.from(sources).forEach((s) => {
    const aid = s.getAttr('attachId');
    if (attachIds.indexOf(aid) >= 0) {
      setAttachLinkIconColorAttr(s, color);
    }
  });
}


export function getAttachLinkedElementGroups(group, stage) {
  if (!group || !stage?.find) return [];

  const partners = [];

  if (group.hasName('source')) {
    const attachId = group.getAttr('attachId');
    if (attachId !== undefined && attachId !== null) {
      const targets = stage.find('.target');
      if (targets?.length) {
        const attachedTarget = Array.from(targets).find(
          (e) => e.getAttr('attachIds')?.indexOf(attachId) >= 0,
        );
        if (attachedTarget && attachedTarget !== group) {
          partners.push(attachedTarget);
        }
      }
    }
  }

  if (group.hasName('target')) {
    const attachIds = group.getAttr('attachIds');
    if (attachIds?.length) {
      const sources = stage.find('.source');
      if (sources?.length) {
        Array.from(sources).forEach((s) => {
          const aid = s.getAttr('attachId');
          if (attachIds.indexOf(aid) >= 0 && s !== group) {
            partners.push(s);
          }
        });
      }
    }
  }

  return partners;
}

export function applyAttachLinkIconColorToCluster(stage, group, color) {
  if (!group?.setAttr || !stage) return;
  setAttachLinkIconColorAttr(group, color);
  getAttachLinkedElementGroups(group, stage).forEach((p) =>
    setAttachLinkIconColorAttr(p, color),
  );
}

export function setLayerLabelColorAttr(group, color) {
  if (!group?.setAttr) return;
  if (color) {
    group.setAttr(LAYER_LABEL_COLOR_ATTR, color);
  } else {
    const key = LAYER_LABEL_COLOR_ATTR;
    if (group.attrs && Object.prototype.hasOwnProperty.call(group.attrs, key)) {
      delete group.attrs[key];
    }
  }
}

export function setAttachLinkIconColorAttr(group, color) {
  if (!group?.setAttr) return;
  if (color) {
    group.setAttr(ATTACH_LINK_ICON_COLOR_ATTR, color);
  } else {
    const key = ATTACH_LINK_ICON_COLOR_ATTR;
    if (group.attrs && Object.prototype.hasOwnProperty.call(group.attrs, key)) {
      delete group.attrs[key];
    }
  }
}
